export default ".encajar {\n  margin-top: 8px;\n  border-radius: 4px !important;\n  height: 39px !important;\n}"